module.exports = __webpack_public_path__ + "static/Appstore-a01ebb82d9fc77169d033d1800127490.png";